import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUtmStore = create(
  persist(
    (set, get) => ({
      // UTM / campaign tracking data captured from URL query params
      utm: {
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
      },
      
      // Whether UTM was captured from URL and should persist across navigation
      utmPersisted: false,

      // Set or merge UTM tracking data (e.g. from URL params)
      setUtmData: (data) => {
        set((state) => ({
          utm: {
            ...state.utm,
            ...data
          },
          utmPersisted: true
        }));
      },
      
      // Reset UTM tracking data to nulls
      resetUtm: () => {
        set(() => ({
          utm: {
            utmSource: null,
            utmMedium: null,
            utmCampaign: null
          },
          utmPersisted: false
        }));
      },
    }),

    { name: "utm-store",
        partialize: (state) => ({
            utm: state.utm
        })
     }
  )
);

export default useUtmStore;